import React from "react";

import DeviceForm from "./DeviceForm";

const AddDevice = () => {
  return <DeviceForm mode="create" />;
};

export default AddDevice;
